import { useContext } from 'react';
import { RequestHeaderContext, RequestHeaderContextType } from '../../contexts/RequestHeaderContext';

export function useRequestHeaderContext(): RequestHeaderContextType {
    return useContext(RequestHeaderContext);
}
